module.exports = __webpack_public_path__ + "static/media/art20.e9a1e155.jpg";